import { useMedia } from 'tamagui'

// Font line height calculator matching the tamagui config font scale
const SCALE_RATIO = (1 + Math.pow(5, 0.25)) / 2
const LINE_HEIGHT_BASE = 16 * SCALE_RATIO

export function fontLineHeight(level: number): number {
  return LINE_HEIGHT_BASE * Math.pow(SCALE_RATIO, level - 5)
}

// Helper to select values by breakpoint using Tamagui's useMedia
export function selectMediaValue<T>(
  media: ReturnType<typeof useMedia>,
  values: T[]
): T {
  if (values.length >= 5 && media.gtLg) return values[4]
  if (values.length >= 4 && media.gtMd) return values[3]
  if (values.length >= 3 && media.gtSm) return values[2]
  if (values.length >= 2 && media.gtXs) return values[1]
  return values[0]
}
